$(document).ready(function () {
  $('.js-slider').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    dots: true,
    items: 1,
    autoplay: true,
    autoplayTimeout: 15000,
    smartSpeed: 2000
  });

  if($(".js-rellax").length){
    var rellax = new Rellax('.js-rellax', {
      center: true,
      round: true,
      vertical: true,
      horizontal: false
    });
  }

  var topPos = $(".menuLine").offset().top;

  $(window).scroll(function (event) {
    var scroll = $(window).scrollTop();
    if(scroll > topPos) {
      $(".menuLine").addClass("fixed");
    } else{
      $(".menuLine").removeClass("fixed");
    }
  });
  
});
